import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const AppPhoneIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="31.604" height="31.624" viewBox="0 0 31.604 31.624">
      <svg width="57" height="60" viewBox="0 0 57 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_168_2)">
          <path
            d="M2.31001 19.03C1.92001 16.88 1.87001 14.72 2.33001 12.57C2.97001 9.57999 4.51001 7.10999 6.68001 5.00999C7.83001 3.88999 9.14001 2.99999 10.63 2.38999C12.44 1.64999 14.04 1.97999 15.46 3.28999C16.33 4.08999 16.97 5.05999 17.54 6.07999C18.8 8.34999 19.81 10.74 20.74 13.16C20.9 13.57 20.99 14 21.1 14.43C21.4 15.65 21.07 16.72 20.29 17.67C19.67 18.43 18.91 19.02 18.08 19.53C17.08 20.15 16.06 20.72 15.06 21.32C14.79 21.48 14.52 21.64 14.28 21.84C13.79 22.25 13.64 22.76 13.91 23.34C14.21 24 14.55 24.64 14.91 25.27C18.91 32.21 24.09 38.11 30.42 42.99C31.04 43.47 31.67 43.94 32.3 44.41C32.47 44.54 32.65 44.66 32.83 44.76C33.55 45.16 34.3 45.11 34.91 44.57C35.27 44.25 35.59 43.88 35.87 43.49C36.5 42.59 37.08 41.65 37.69 40.75C37.92 40.41 38.19 40.08 38.46 39.77C39.52 38.56 40.87 38.19 42.38 38.66C43.34 38.96 44.26 39.39 45.17 39.83C46.87 40.64 48.51 41.57 50.04 42.67C51.2 43.5 52.35 44.35 53.23 45.5C54.24 46.82 54.49 48.27 53.88 49.82C53.7 50.27 53.48 50.72 53.22 51.13C51.62 53.71 49.32 55.44 46.53 56.56C44.4 57.42 42.19 57.66 39.91 57.46C37.26 57.23 34.76 56.45 32.33 55.41C29.22 54.08 26.3 52.42 23.54 50.47C18.57 46.95 14.33 42.69 10.76 37.76C8.40001 34.51 6.41001 31.04 4.82001 27.34C3.85001 25.09 3.05001 22.8 2.53001 20.4C2.43001 19.95 2.38001 19.49 2.31001 19.03Z"
            stroke="#023939"
            stroke-width="4"
            stroke-miterlimit="10"
          />
          <path
            d="M53.58 24.39C53.58 24.39 53.98 16 48.01 9.29C41.94 2.47 33.66 2 33.66 2"
            stroke="#32B88E"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
          <path
            d="M44.72 25.03C44.72 25.03 44.98 19.68 41.17 15.4C37.36 11.12 32.02 10.75 32.02 10.75"
            stroke="#32B88E"
            stroke-width="4"
            stroke-miterlimit="10"
            stroke-linecap="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_168_2">
            <rect width="56.21" height="59.52" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
